import http from './http';

export default {
  create(data) {
    return http().post(`/v1/tasks`, data);
  },
  attachedListToRecord(recordId, taskListId) {
    return http().post(`v1/tasks/record/${recordId}/task-list/${taskListId}`)
  },
  update(data) {
    return http().put(`/v1/tasks/${data.id}`, data)
  },
  updateStatus(id, data) {
    return http().put(`/v1/tasks/${id}/update-status`, data)
  },
  delete(id) {
    return http().delete(`/v1/tasks/${id}`);
  },
}
